import {useMutation, UseMutationOptions} from 'react-query'

import {CancellationRequestStatus} from '../../../../features/rmc/orderCancellation/types/cancellationRequest.types'
import {OrderCancellation} from '../../../../OrderIntake/declarations/types'
import {mutations} from '../../mutations'
import {hubQueryClient} from '../../QueryProvider'

interface CancelOrderVariables {
  orderId: string
  cancelOrderPayload: OrderCancellation
}

type UseCancelOrderOptions = Omit<
  UseMutationOptions<CancellationRequestStatus, Error, CancelOrderVariables>,
  'mutationFn'
>

export const useCancelOrder = (options?: UseCancelOrderOptions) => {
  return useMutation(mutations.cancelOrderRequest, {
    ...options,
    onSuccess: (request, variables, context) => {
      hubQueryClient.setQueryData(['cancellationRequestStatus', variables.orderId], request)
      options?.onSuccess?.(request, variables, context)
    }
  })
}
